<script setup>
import { Link } from '@inertiajs/vue3'
defineProps({ delivery: { type: Object, required: true }, showClaim: { type: Boolean, default: false } })
</script>

<template>
  <Link :href="`/deliveries/${delivery.id}`" class="row">
    <div class="row__main">
      <div class="row__kind">{{ delivery.kind === 'handover' ? '↗' : '↙' }}</div>
      <div class="row__body">
        <p class="row__addr">{{ delivery.address }}</p>
        <p class="row__time">{{ delivery.scheduled_for || 'no scheduled time' }}</p>
      </div>
    </div>
    <span v-if="showClaim" class="row__claim">Claim →</span>
  </Link>
</template>

<style scoped>
.row {
  display: flex; align-items: center; justify-content: space-between;
  padding: 0.85rem 1rem; background: var(--surface); border: 1px solid var(--line);
  border-radius: 0.75rem; margin-bottom: 0.5rem; text-decoration: none; color: var(--ink);
  min-height: 4rem;
}
.row__main { display: flex; gap: 0.75rem; align-items: center; }
.row__kind { font-size: 1.5rem; color: var(--accent); }
.row__addr { margin: 0; font-weight: 500; }
.row__time { margin: 0.15rem 0 0; font-size: 0.8125rem; color: var(--muted); }
.row__claim { color: var(--accent); font-weight: 600; font-size: 0.875rem; }
</style>
